/**
 * AgentSearch
 * 
 * @Author: Focci
 * @Date: 2023-08-28 17:02:58
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-28 17:02:58
 */

'use client'

import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import AgentAutocomplete from '@comp/page/common/filter/agent/AgentAutocomplete'
import AgentSearchOptions from './options'

export default function AgentSearch({
  size = 'medium',
  needClosePanel = false,
  autocompleteDefaultValue,
}) {
  const [open, setOpen] = useState(false)
  const [suburbId, setSuburbId] = useState()
  const [suburbName, setSuburbName] = useState()

  const handleChange = useCallback(({ label, value }) => {
    setSuburbId(value)
    setSuburbName(label)
    setOpen(true)
  }, [])

  return (
    <div className="mt-4 max-w-120">
      <div className="bg-white rounded-[0.25rem]">
        <AgentAutocomplete 
          value={autocompleteDefaultValue}
          onChange={handleChange}
          autocompleteProps={{ size }}
        />
      </div>
      {open && (
        <AgentSearchOptions
          suburbId={suburbId}
          suburbName={suburbName}
          onSubmit={() => needClosePanel && setOpen(false)}
        />
      )}
    </div>
  )
}

AgentSearch.propTypes = {
  size: PropTypes.string,
}
